var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel"
  }, [_vm.loading ? _c('div', {
    staticClass: "bcg-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('applications-wrapper')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }